/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext } from 'react';
import { API_BASE_URL, FOLD_ENVIRONMENT } from '../config/environment';

const currentEnv = FOLD_ENVIRONMENT;
const apiBaseUrl = API_BASE_URL;

const ENVIRONMENT_STYLES = {
  localhost: { name: 'Localhost', color: '#22C55E', bgColor: '#DCFCE7', textColor: '#166534' },
  development: { name: 'Development', color: '#3B82F6', bgColor: '#DBEAFE', textColor: '#1E40AF' },
  staging: { name: 'Staging', color: '#F59E0B', bgColor: '#FEF3C7', textColor: '#92400E' },
  production: { name: 'Production', color: '#EF4444', bgColor: '#FEE2E2', textColor: '#991B1B' },
};

const style = ENVIRONMENT_STYLES[currentEnv] || ENVIRONMENT_STYLES.localhost;
const value = {
  currentEnv,
  apiBaseUrl,
  envConfig: { ...style, apiUrl: apiBaseUrl },
  envName: style.name,
  envColor: style.color,
  envBgColor: style.bgColor,
  envTextColor: style.textColor,
  isProduction: currentEnv === 'production',
};

const EnvironmentContext = createContext(value);

export function EnvironmentProvider({ children }) {
  return <EnvironmentContext.Provider value={value}>{children}</EnvironmentContext.Provider>;
}

export function useEnvironment() {
  return useContext(EnvironmentContext);
}
